import { Component, DestroyRef, Inject, inject, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import * as fromApp from '@store';
import { CountyInfo, GisService } from '@core/api/gis.service';

@Component({
  selector: 'fc-dialog-edit-county-data',
  templateUrl: './dialog-edit-county-data.component.html',
  styleUrl: './dialog-edit-county-data.component.scss',
  standalone: false
})
export class DialogEditCountyDataComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  updateCountyForm: UntypedFormGroup;
  countyData: CountyInfo;

  constructor(
    readonly store: Store<fromApp.AppState>,
    public dialogRef: MatDialogRef<DialogEditCountyDataComponent>,
    public dialog: MatDialog,
    public gisService: GisService,
    readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.countyData = data.countyData;
  }

  ngOnInit(): void {
    this.updateCountyForm = this.formBuilder.group({
      county: new FormControl({ value: this.countyData.county, disabled: true }),
      state: new FormControl({ value: this.countyData.state, disabled: true }),
      regridFile: new FormControl({ value: this.countyData.regridFile, disabled: true }),
      available: new FormControl(this.countyData.available),
      averageErt: new FormControl(this.countyData.averageErt),
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    this.gisService
      .updateCountyData(
        this.countyData.gid,
        this.updateCountyForm.value.available,
        this.updateCountyForm.value.averageErt
      )
      .subscribe(() => {
        this.dialogRef.close();
      });
  }
}
